module.exports = __webpack_public_path__ + "static/carousel-3-a9a47a90aeb4c7dce94bac75ee1660f2.png";